import { Credentials } from "../common/credentials.js";
import { ApiType, request } from "./api.js";
import { TokenGroup } from "./types/token.js";
import { captureException } from "../common/errors.js";

export async function getTokenSetExport(
  credentials: Credentials,
  tokenSetId: number,
  clientUserAgent?: string,
): Promise<TokenGroup | null> {
  try {
    return await request<TokenGroup>(
      `/token_management/token_set/${tokenSetId}/export`,
      credentials,
      { method: "GET" },
      new URLSearchParams({ format: "w3c" }),
      ApiType.Internal,
      { clientUserAgent },
    );
  } catch (e) {
    captureException(e);
    return null;
  }
}
